export const vtsMapping = (vts: string): string => {
  switch (vts) {
    case 'Commercial':
      return 'vts[]=4&vts[]=5&vts[]=14&vts[]=1';
    case 'Hybrid':
      return 'vts[]=6';
    case 'Stationwagon':
      return 'vts[]=7';
    case 'Sports':
      return 'vts[]=8';
    case 'SUV':
      return 'vts[]=9';
    case 'MPV':
      return 'vts[]=10';
    case 'Hatchback':
      return 'vts[]=11';
    case 'Luxury':
      return 'vts[]=12';
    case 'Sedan':
      return 'vts[]=13';
    default:
      return 'vts[]=0';
  }
};

export const prcMapping = (price: number): string => {
  const ranges = [
    { min: 0, max: 10000 },
    { min: 10001, max: 20000 },
    { min: 20001, max: 30000 },
    { min: 30001, max: 40000 },
    { min: 40001, max: 50000 },
    { min: 50001, max: 60000 },
    { min: 60001, max: 70000 },
    { min: 70001, max: 80000 },
    { min: 80001, max: 100000 },
    { min: 100001, max: 120000 },
    { min: 120001, max: 140000 },
    { min: 140001, max: 160000 },
    { min: 160001, max: 200000 },
    { min: 200001, max: Number.MAX_VALUE },
  ];

  for (const range of ranges) {
    if (price >= range.min && price <= range.max) {
      if (range.max === Number.MAX_VALUE) {
        return `&pr1=${range.min}`;
      }
      return `&pr1=${range.min}&pr2=${range.max}`;
    }
  }

  return '&pr1=&pr2=';
};
